/* Phase 4.2.2-γ — Shared sub-components for the Workflow Timeline surface.
 * Rendered by both LandingPages.WorkflowTimelineCard and
 * WorkflowInstanceDetail. */
import { useT } from "../../lib/i18n";

const KNOWN_REASONS = {
  condition_false: "landing_pages.workflow.skip_reason.condition_false",
  adapter_returned_none: "landing_pages.workflow.skip_reason.adapter_legacy",
  "on_giveup:skip_step": "landing_pages.workflow.skip_reason.on_giveup_skip",
};

function _formatSnapshot(snap) {
  // {"steps.draft_lp.outputs.hero.hero_image_prompt": ""} → compact one-liner
  if (!snap || typeof snap !== "object") return null;
  return Object.entries(snap).map(([k, v]) => {
    const val = v === null || v === undefined
      ? "null"
      : (typeof v === "string"
          ? (v ? `"${v.length > 30 ? v.slice(0, 30) + "…" : v}"` : '""')
          : JSON.stringify(v));
    return `${k} = ${val}`;
  }).join("; ");
}

export function SkippedReason({ step, testid }) {
  const t = useT();
  const reasonKey = KNOWN_REASONS[step.reason];
  const label = reasonKey ? t(reasonKey) : step.reason;
  const snap = step.condition_snapshot;
  return (
    <span className="inline-flex flex-col gap-0.5"
          data-testid={`${testid}-reason`}>
      <span className="text-[11px] text-muted-foreground italic"
            data-testid={`${testid}-reason-label`}>{label}</span>
      {snap && Object.keys(snap).length > 0 && (
        <code className="text-[10px] font-mono bg-muted px-1.5 py-0.5 rounded text-muted-foreground"
              data-testid={`${testid}-reason-snapshot`}>
          {_formatSnapshot(snap)}
        </code>
      )}
    </span>
  );
}

export function AttemptBadge({ attempts, status, testid, maxAttempts }) {
  const t = useT();
  const n = attempts.length;
  const m = maxAttempts || n;
  // Amber when retries happened AND step ultimately succeeded (transient
  // failure absorbed); red when terminal failure.
  const failed = status === "failed" || status === "failed_continue";
  const tone = failed
    ? "bg-rose-100 text-rose-900 ring-rose-200"
    : "bg-amber-100 text-amber-900 ring-amber-200";
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-mono ring-1 ${tone}`}
          title={attempts.map((a, i) =>
            `#${i + 1}: ${a.error ? "✗ " + a.error : "✓"}`).join("\n")}
          data-testid={testid}>
      {t("landing_pages.workflow.attempt_badge", { n, m })}
    </span>
  );
}
